import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Button from "./Button";
import theme from "./theme";

const Wrapper = styled.div`
  display: inline-flex;
  vertical-align: middle;
  position: relative;
  line-height: 1;

  & > button + button {
    margin-left: -2px;
  }

  & button {
    position: relative;
    z-index: 1;
  }

  & button:active {
    z-index: 2;
  }
`;

const MainButton = styled(Button)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
`;

const ToggleButton = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  padding-left: ${theme.small};
  padding-right: ${theme.small};

  display: inline-flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: "▾";
    font-size: 0.8rem;
  }
`;

const Menu = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;

  margin: 0;
  padding: 6px 0;
  list-style: none;

  min-width: 200px;
  z-index: 9999;

  background: white;
  border-radius: 6px;
  
  box-shadow:
          0 4px 11px rgba(0, 0, 0, 0.1),
          0 1px 3px rgba(0, 0, 0, 0.08);

  border: 1px solid rgba(0, 0, 0, 0.08);
`;

const MenuItem = styled.li`
  padding: 8px 12px;
  cursor: pointer;

  display: flex;
  align-items: center;

  font-size: 14px;

  color: ${theme.grey1};

  transition: background 0.15s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  &:active {
    background: rgba(0, 0, 0, 0.08);
  }

  .icon-left {
    margin-right: 10px;
    color: ${theme.grey2};
  }
`;

export default function SplitButton({
                                      label,
                                      icon: Icon,
                                      onClick,
                                      options = [],
                                      className,
                                      disabled
                                    }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <Wrapper ref={ref}>
      <MainButton
        className={className}
        disabled={disabled}
        onClick={onClick}
      >
        {Icon && <Icon className="icon-left" />}
        {label}
      </MainButton>

      <ToggleButton
        className={className}
        disabled={disabled}
        onClick={() => setOpen(v => !v)}
      />

      {open && (
        <Menu>
          {options.map((opt, idx) => {
            const ItemIcon = opt.icon;

            return (
              <MenuItem
                key={idx}
                onClick={(ev) => {
                  opt.onClick?.(ev);
                  setOpen(false);
                }}
              >
                {ItemIcon && <ItemIcon className="icon-left" />}
                {opt.label}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </Wrapper>
  );
}